const quizId = document.querySelector(".pageheader .header-btn").getAttribute('href').replace('#quiz-', '');
const quizCookieName = `prq-recommended-products-${quizId}`;

function prqSetCookie(name, value, days) {
  const date = new Date();
  date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
  document.cookie = `${name}=${value};expires=${date.toUTCString()};path=/`;
}

function prqGetCookie(name) {
  const cookies = document.cookie.split(';').map(cookie => cookie.trim());
  const cookie = cookies.find(cookie => cookie.startsWith(`${name}=`));
  return cookie ? cookie.substring(name.length + 1) : "";
}

function prqDelCookie(name) {
  document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;`;
}

function onMessage(event) {
  if (event.origin !== "https://admin.revenuehunt.com") return;
  const { data } = event;
  if (typeof window[data.func] === "function") {
    window[data.func]();
  }
}

window.addEventListener("message", onMessage, false);

function prqQuizRetake() {
  prqDelCookie(quizCookieName);
  clearRecommendedProductsLabel();
  setSkinQuizButton(window.skin_quiz.strings.button_label);
}

function prqQuizCallback(quizResponse) {
  const recommendedProducts = quizResponse.response.attributes.recommended_products.map(product => product.origin_id);
  // console.log('recommendedProducts', recommendedProducts);
  prqSetCookie(quizCookieName, encodeURIComponent(JSON.stringify(recommendedProducts)), 7);
  initRecommendedProductsLabel();
  setSkinQuizButton(window.skin_quiz.strings.completed_label);
}

function setSkinQuizButton(text) {
  document.querySelectorAll(".pageheader .header-btn, .mobile-navigation-drawer__footer .header-btn")
    .forEach(btn => btn.innerText = text);
}

function addRecommendedLabel(labelList, recommendedLabelHTML) {
  const labelContainer = document.createElement('div');
  labelContainer.className = "product-label-container";
  labelContainer.innerHTML = recommendedLabelHTML;
  labelList.appendChild(labelContainer);
}

function initRecommendedProductsLabel() {
  const cookieValue = prqGetCookie(quizCookieName);
  const recommendedLabelHTML = `<span class="product-label product-label--recommended"><span>${window.skin_quiz.strings.recommended_label}</span></span>`;

  if (cookieValue) {
    const recommendedProducts = JSON.parse(decodeURIComponent(cookieValue));

    // Add recommended product label to the existing product label list
    recommendedProducts.forEach(productId => {
      document.querySelectorAll(`.product-label-list[data-product-id='${productId}']`).forEach(labelList => {

        const labelContainers = labelList.getElementsByClassName('product-label-container');
        // Add just the recommended product label if there is no other label
        if (labelContainers.length === 0) {
          addRecommendedLabel(labelList, recommendedLabelHTML);
        }
        else {
          [...labelContainers].forEach(container => {
            // add recommended product label if it is not already recommended (avoid duplicate)
            if (!container.querySelector('.product-label--recommended')) {
              // remove last label if there is two or more labels
              if (container.children.length >= 2) container.removeChild(container.lastChild);
              container.insertAdjacentHTML('afterbegin', recommendedLabelHTML);
            }
          });
        }

        // Change the script for variant selector so to show the recommended product list
        [...labelList.getElementsByTagName('script')].forEach(script => {
          const html = new DOMParser().parseFromString(script.innerHTML, 'text/html').body;

          const labelContainer = html.querySelector('.product-label-container');

          // Add just the recommended product label into script if there is no other label
          if (!labelContainer) {
            const tempContainer = document.createElement('div');
            addRecommendedLabel(tempContainer, recommendedLabelHTML);
            script.insertAdjacentHTML('afterbegin', tempContainer.innerHTML);
          }
          else {
            if (!labelContainer.querySelector('.product-label--recommended')) {
              // remove last label if there is more than one label
              if (labelContainer.children.length >= 2) labelContainer.removeChild(labelContainer.lastChild);
              
              // add the recommended product label to the script tag
              labelContainer.insertAdjacentHTML('afterbegin', recommendedLabelHTML);
              script.innerHTML = html.innerHTML;
            }
          }
        });
      });
    });
  }
}

function clearRecommendedProductsLabel() {
  // clear all recommended labels if no cookie
  [...document.getElementsByClassName('product-label-list')].forEach(list => {
    list.querySelectorAll('.product-label--recommended').forEach(label => label.remove());
    list.querySelectorAll('script').forEach(script => {
      const html = new DOMParser().parseFromString(script.innerHTML, 'text/html').body;
      html.querySelectorAll('.product-label--recommended').forEach(label => label.remove());
      script.innerHTML = html.innerHTML;
    });
  });
}

document.addEventListener("DOMContentLoaded", () => {
  initRecommendedProductsLabel();
  if (prqGetCookie(quizCookieName)) {
    setSkinQuizButton(window.skin_quiz.strings.completed_label);
  }
});

// Need to dispatch this event on main-search.js and related-products.liquid
document.addEventListener("refreshRecommendedProductsLabel", () => {
  initRecommendedProductsLabel();
});